import Card from "../shared/card";
import Typography from "../shared/typography";
import { formatTimeStampToHumanReadableDate } from "../utls/time";
import RecordMetaGrid, {
  RecordMetaItem,
} from "./record-meta-grid";

interface RecordItemProps {
  item: Record<string, any>;
  onClick?: () => void;
}

function renderValue(value: any): string {
  if (typeof value === "string") {
    const parsed = Date.parse(value);
    if (!isNaN(parsed) && value.includes("-") && value.includes("T")) {
      return formatTimeStampToHumanReadableDate(value);
    }
    return value;
  }
  if (typeof value === "number") {
    return value.toString();
  }
  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }
  return JSON.stringify(value);
}

function formatKey(key: string): string {
  const spaced = key
    .replace(/_/g, " ")
    .replace(/([A-Z])/g, " $1")
    .trim();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

export default function RecordItem({ item, onClick }: RecordItemProps) {
  const { id, name, ...rest } = item;
  const displayName =
    name ||
    [
      (item as any).firstName || (item as any).first_name,
      (item as any).lastName || (item as any).last_name,
    ]
      .filter(Boolean)
      .join(" ");
  const metaItems: RecordMetaItem[] = Object.entries(rest)
    .filter(([, value]) => value !== null && value !== undefined)
    .map(([key, value]) => ({
      label: formatKey(key),
      value: renderValue(value),
    }));

  return (
    <Card
      variant="cream"
      elevation={1}
      className="w-full"
      onClick={onClick}
      hoverEffect={!!onClick}
    >
      <Card.Body className="space-y-1">
        {displayName && (
          <Typography variant="subtitle1" className="text-brown-800">
            {displayName}
          </Typography>
        )}
        <RecordMetaGrid
          items={metaItems}
          columnsClassName="sm:grid-cols-2 lg:grid-cols-4"
        />
      </Card.Body>
    </Card>
  );
}
